import { render, staticRenderFns } from "./news_details.vue?vue&type=template&id=4660c888&scoped=true&"
import script from "./news_details.vue?vue&type=script&lang=js&"
export * from "./news_details.vue?vue&type=script&lang=js&"
import style0 from "./news_details.vue?vue&type=style&index=0&id=4660c888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660c888",
  null
  
)

export default component.exports